<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card tab2-card">
                <div class="card-body tab2-card">
                    <form [formGroup]="impossibilitySupplyForm" class="needs-validation" novalidate>
                        <div class="form-group row">
                            <label>{{cui}}</label>
                            <div class="col-xl-3 col-md-3">
                                <input class="form-control" formControlName="cui" type="text" />
                            </div>
                            <label>{{supplierName}}</label>
                            <div class="col-xl-3 col-md-3">
                                <input class="form-control" type="text" formControlName="supplierName" />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="bold">{{decisionImpossibilityOfSupply}}</label>
                        </div>
                        <div class="form-group row">
                            <label>{{startDate}}<span>*</span></label>
                            <div class="col-xl-3 col-md-3">
                                <input [ngClass]="onDisplayRequiredField('startDate')" class="form-control" type="date"
                                    [min]="minDate | date:'yyyy-MM-dd'" formControlName="startDate"
                                    onkeydown="return false" required />
                            </div>
                        </div>
                        <div class="form-group row">
                            <label>{{impossibilityReason}}<span>*</span></label>
                            <div class="col-xl-3 col-md-3">
                                <textarea [ngClass]="onDisplayRequiredField('impossibilityReason')" class="form-control"
                                    rows="4" formControlName="impossibilityReason" required></textarea>
                            </div>
                        </div>
                    </form>
                    <div class=" card-footer row pull-right">
                        <button type="button" class="btn btn-primary" (click)="onTransferringCustomersToFUI()">
                            {{transferringCustomersToFUI}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>